/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type EnterHardwareLotteryMutationVariables = Types.Exact<{
  sku_code: Types.Scalars["String"];
  event_id: Types.Scalars["Float"];
}>;

export type EnterHardwareLotteryMutation = {
  enterHardwareLottery: Pick<
    Types.HardwareLotteryEntry,
    | "id"
    | "status"
    | "user_id"
    | "event_id"
    | "sku_code"
    | "created_at"
    | "updated_at"
  >;
};

export const EnterHardwareLotteryDocument = gql`
  mutation EnterHardwareLottery($sku_code: String!, $event_id: Float!) {
    enterHardwareLottery(sku_code: $sku_code, event_id: $event_id) {
      id
      status
      user_id
      event_id
      sku_code
      created_at
      updated_at
    }
  }
`;

/**
 * __useEnterHardwareLotteryMutation__
 *
 * To run a mutation, you first call `useEnterHardwareLotteryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterHardwareLotteryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterHardwareLotteryMutation, { data, loading, error }] = useEnterHardwareLotteryMutation({
 *   variables: {
 *      sku_code: // value for 'sku_code'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useEnterHardwareLotteryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EnterHardwareLotteryMutation,
    EnterHardwareLotteryMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    EnterHardwareLotteryMutation,
    EnterHardwareLotteryMutationVariables
  >(EnterHardwareLotteryDocument, baseOptions);
}
export type EnterHardwareLotteryMutationHookResult = ReturnType<
  typeof useEnterHardwareLotteryMutation
>;
export type EnterHardwareLotteryMutationResult =
  ApolloReactCommon.MutationResult<EnterHardwareLotteryMutation>;
export type EnterHardwareLotteryMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EnterHardwareLotteryMutation,
    EnterHardwareLotteryMutationVariables
  >;
